import {
  castArray,
  cloneDeep,
  difference,
  uniqBy,
  // get as _get,
  flatten,
} from 'lodash-es'
import { fileterHiddenFields } from '@ow/ditto-core'
import { getQuery } from '@vt/utils'
import { getFiltersAfterproducts } from './utils'

const swap = (list, i, j) => {
  const newList = [...list]
  newList[i] = list[j]
  newList[j] = list[i]
  return newList
}

// 处理筛选嵌套赋值
const dealInitialFilters = (initialFilters, userInfo, mergeRecycle) => {
  const queries = (initialFilters.queries || []).map((item) => {
    if (item.value === 'userInfo.orgId') {
      return {
        ...item,
        value: userInfo.orgId,
        default: true,
      }
    }
    if (item.value === 'userInfo.id') {
      return {
        ...item,
        value: userInfo.id,
        default: true,
      }
    }
    console.log(userInfo, 'userInfouserInfo')
    if (item.value === 'userInfo.orgName') {
      return {
        ...item,
        value: userInfo.orgName,
        default: true,
      }
    }
    if (item.queries && item.queries.length) {
      const arr = dealInitialFilters(
        {
          queries: item.queries,
          logicType: item.logicType,
        },
        userInfo,
        false
      )
      return { ...item, default: true, queries: arr }
    }
    return { ...item, default: true }
  })

  if (mergeRecycle) {
    // 非回收站的在此初始化设置
    return [
      ...queries,
      {
        slug: 'isFakeDeleted',
        value: true,
        queryType: ['notEqual'],
      },
    ]
  }
  return queries
}

const dealDefaultFilters = (mergeFilters, defaultFilters) => {
  const { queries: defaultQueries = [] } = defaultFilters || {}
  const { queries: _mergeQueries = [] } = mergeFilters || {}
  return {
    ...defaultFilters,
    ...mergeFilters,
    queries: uniqBy([...defaultQueries, ..._mergeQueries], 'slug'),
  }
}

const isEmpty = (value) => {
  if (value === null || value === undefined || value === '') {
    return true
  }
  return false
}

const finalFetchDataFilters = (filters, fields) => {
  const { queries } = filters
  const arr = (queries || [])
    .map((v) => {
      const obj = fields.find((d) => d.slug === v.slug && d.type === 'product')
      if (obj && v.slug !== 'isFakeDeleted') {
        return null
      }
      // 当前项没有值，则不作为查询条件(判空除外)
      if (
        isEmpty(v.value) &&
        !['isNull', 'notNull'].includes(v.queryType) &&
        !v.default
      ) {
        return null
      }

      // 编号筛选特殊处理
      if (
        v.slug === 'tableDataId' &&
        v.value.includes('/') &&
        ['inList', 'containString', 'notContainString'].includes(v.queryType)
      ) {
        return {
          queryType:
            v.queryType === 'containString' || v.queryType === 'inList'
              ? 'inList'
              : 'notInList',
          slug: 'tableDataId',
          value: v.value.split('/'),
        }
      }
      return v
    })
    .filter((v) => v)
  return { ...filters, queries: arr }
}
const mergeQueries = (filters, defaultFilters, mergeFilters = {}) => {
  const { queries: defaultQueries = [], force } = defaultFilters || {}
  if (Object.keys(filters).length !== 0) {
    const _filters = cloneDeep(filters)
    const arr = []
    if (mergeFilters.queries) {
      mergeFilters.queries.forEach((que) => {
        const { slug, queryType, fixed } = que
        let flag = false
        _filters.queries.forEach((q) => {
          if (
            q.slug === slug &&
            (q.queryType.toString() === queryType.toString() ||
              (q.fixed && fixed) ||
              q.queryType.toString() !== queryType.toString())
          ) {
            // 如果固定筛选和默认筛选字段重复，首先选择固定筛选的值，其次是默认筛选的
            if (!isEmpty(que.value)) {
              q.value = que.value
            }
            q.queryType = que.queryType
            q.remove = que.remove
            q.resume = que.resume
            flag = true
          }
        })
        if (!flag) {
          arr.push(que)
        }
      })
    }
    arr.forEach((q) => {
      _filters.queries.push(q)
    })

    const finalQueries = _filters.queries
      .filter((v) => v.remove !== true)
      .map((v) => {
        const defaultSlugs = defaultQueries.map((d) => d.slug)
        const obj = defaultQueries.find((d) => d.slug === v.slug)
        if (
          (v.resume || (obj && obj.resume)) &&
          defaultSlugs.includes(v.slug)
        ) {
          return defaultQueries.find((d) => d.slug === v.slug)
        }

        return v
      })
    return {
      ..._filters,
      queries: force
        ? uniqBy([...finalQueries, ...defaultQueries], 'slug')
        : flatten(finalQueries),
    }
  }
  const finalQueries = mergeFilters.queries
    .filter((v) => v.remove !== true)
    .map((v) => {
      const defaultSlugs = defaultQueries.map((d) => d.slug)
      const obj = defaultQueries.find((d) => d.slug === v.slug)

      if ((v.resume || (obj && obj.resume)) && defaultSlugs.includes(v.slug)) {
        return defaultQueries.find((d) => d.slug === v.slug)
      }

      return v
    })
  return {
    ...mergeFilters,
    queries: force
      ? [...finalQueries, ...defaultQueries]
      : flatten(finalQueries),
  }
}

// 目前后端只满足单个字段排序
const mergeSorts = (sorts = [], _mergeSorts = []) => {
  if (!_mergeSorts.length) {
    return sorts
  }

  return _mergeSorts
}

const initColumnShowType = (
  config,
  fields,
  vtProject,
  appId,
  tbSlug,
  vid,
  userInfoInApp
) => {
  const { showTypeMode = 'show', fields: listFields = [] } = config || {}
  const listSlugs = listFields.map((v) => v.slug)
  const arr = vtProject.getStorage(
    `${appId}_${tbSlug}_${vid}_${userInfoInApp.userId}_listConfig`
  )

  if (arr && arr.length) {
    return arr
  }
  if (showTypeMode === 'hidden') {
    return fields.reduce((total, field) => {
      if (
        !listSlugs.includes(field.slug) &&
        field.type !== 'product' &&
        field.group !== 'system'
      ) {
        total.push({ slug: field.slug, showType: 'show' })
      }
      return total
    }, [])
  }

  return listFields
  // return fields.reduce((total, field) => {
  //   if (listSlugs.includes(field.slug)) {
  //     const _field = listFields.find((v) => v.slug === field.slug)

  //     total.push(_field)
  //   } else if (field.type !== 'product' && field.group !== 'system') {
  //     total.push({ slug: field.slug, showType: 'hidden' })
  //   }
  //   return total
  // }, [])
}
//   1. 其实还应该有权限叠加的数据
//   2. 以及当 tbDefs 有变化时, 其实应该重新构建数据, 不过一般来说不会发生
//   2 先不处理吧

export default function createTbViewStore(
  ditto,
  // eslint-disable-next-line default-param-last
  initState = {},
  extendsStore,
  extendsHooks,
  userInfoInApp,
  vtProject
) {
  const { vid } = getQuery()
  const { tbDefs, appId, tbSlug } = ditto

  return (set, get) => {
    const setCurrentPageIds = (currentPageIds) =>
      set(() => ({ currentPageIds }))

    const setTbData = async (setter) => {
      const { tbData: pre } = get()
      set(() => ({
        tbData: typeof setter === 'function' ? setter(pre) : setter,
      }))
    }

    const setShowRecycle = (showRecycle) => {
      const { setFilters } = get()
      set(() => ({ showRecycle }))
      setFilters({
        logicType: 'and',
        queries: [
          {
            slug: 'isFakeDeleted',
            value: true,
            queryType: showRecycle ? ['equal'] : ['notEqual'],
          },
        ],
      })
    }

    /**
     * 更新合并filters
     * @param {object} _mergeFilters 新的filters
     * @param {boolean} reset 是否重置
     * @param {boolean} reload 是否需要重新fetch（目前在设置导出过滤条件的时候设置为false）
     */
    const setFilters = (_mergeFilters, reset, reload = true) => {
      const { filters, fetchTbData, defaultFilters = {}, fields = [] } = get()

      const afterproducts = getFiltersAfterproducts(_mergeFilters)

      const mergedFilters =
        reset || !filters
          ? dealDefaultFilters(afterproducts, defaultFilters)
          : mergeQueries(filters, defaultFilters, afterproducts)

      console.log(mergedFilters, 'mergedFiltersmergedFilters')
      set(() => ({
        filters: mergedFilters,
        finalFetchDataFilters: finalFetchDataFilters(mergedFilters, fields),
        pageNum: 0,
      }))
      if (reload) {
        fetchTbData()
      }
    }

    const setSorts = (_mergeSorts, reset) => {
      const { sorts, fetchTbData } = get()
      const arr = castArray(_mergeSorts)
      set(() => ({
        sorts: reset || !sorts ? arr : mergeSorts(sorts, arr),
        pageNum: 0,
      }))
      fetchTbData()
    }

    const setOrder = ({ oldIndex, newIndex }) => {
      if (oldIndex === newIndex) return

      const { tbData } = get()

      const data = [...tbData]
      const [removed] = data.splice(oldIndex, 1)
      data.splice(newIndex, 0, removed)

      set(() => ({
        tbData: data,
      }))
    }

    const setSelectedIds = (ids) => {
      const { tbData } = get()

      set(() => ({
        selectedIds: ids === 'all' ? tbData.map((v) => v.objectId) : ids,
      }))
    }

    const setClickedInfo = (info) => {
      set(() => ({
        clickedInfo: info,
      }))
    }

    // 合并为一个方法，防止数据请求两次
    const setPage = (pageSize, pageNum) => {
      const { fetchTbData } = get()
      set(() => ({ pageSize, pageNum, selectedIds: [] }))
      fetchTbData()
    }

    const setPageSize = (pageSize) => {
      const { fetchTbData } = get()
      set(() => ({ pageSize, selectedIds: [] }))
      fetchTbData()
    }

    const setPageNum = (pageNum) => {
      const { fetchTbData } = get()
      set(() => ({ pageNum, selectedIds: [] }))
      fetchTbData()
    }

    const setColumnShowType = (columnShowType) => {
      // const { columnShowType } = get()
      // const index = findIndex(columnShowType, (v) => v.slug === slug)
      // const arr = [...columnShowType]
      // arr.splice(index, 1, { slug, showType: show ? 'show' : 'hidden' })

      set(() => ({
        columnShowType,
      }))
    }

    const setFields = (fields) => {
      set(() => ({
        fields,
      }))
    }

    const listConfigArr =
      initState.listConfig &&
      initState.listConfig.fields &&
      initState.listConfig.fields.length
        ? initColumnShowType(
            initState.listConfig || [],
            tbDefs.fields,
            vtProject,
            appId,
            tbSlug,
            vid,
            userInfoInApp
          )
        : []

    const filtersArr = fileterHiddenFields(tbDefs.fields || []) || []
    const columnShowType = listConfigArr.length
      ? listConfigArr
      : filtersArr.reduce((total, field) => {
          if (field.type !== 'product') {
            total.push({ slug: field.slug, showType: 'show' })
          }
          return total
        }, [])

    const initedState = {
      loading: false,
      pageNum: 0,
      currentPageIds: [],
      selectedIds: [],
      clickedInfo: {},
      tbData: [],
      tbId: tbDefs.tbId,
      tbSlug: tbDefs.tbSlug,
      info: tbDefs.info,
      fields: tbDefs.fields,
      total: ditto.total,
      // paged, all, paged-all, filtered-all
      // 这里指定获取数据的方式，分页获取，全部获取，分页全部获取
      // 对于点位指标那种还可以按照层级增量获取
      fetdataMode: 'paged',
      columnShowType,
      dataCheckDisabled: false,
      ditto,
      tbDefs,
      currentDate: `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
      ...initState,
      pageSize: initState.pageSize || 50,
    }

    // const init = (ditto, tbDefs, viewConfig) => {
    //   // 需重置
    //   set(() => ({
    //     inited: true,
    //     loading: true,
    //     ditto,
    //     tbId: tbDefs.tbId,
    //     tbSlug: tbDefs.tbSlug,
    //     info: tbDefs.info,
    //     fields: tbDefs.fields,
    //     pageNum: 0,
    //     currentPageIds: [],
    //     selectedIds: [],
    //     tbData: [],
    //     currentDate: `${new Date().getFullYear()}-${new Date().getMonth() + 1}`,
    //     ...viewConfig,
    //     pageSize: viewConfig.pageSize || 50,
    //   }))
    // }

    const setActions = {
      setLoading: (loading) => set(() => ({ loading })),
      setDataCheckDisabled: (dataCheckDisabled) =>
        set(() => ({ dataCheckDisabled })),
      setPage,
      setPageSize,
      setPageNum,
      setTotal: (total) => set(() => ({ total })),
      setShowRecycle,
      setSorts,
      setOrder,
      setFilters,
      setCurrentPageIds,
      setTbData,
      setCurrentDate: (currentDate) => set(() => ({ currentDate })),
      setSelectedIds,
      setClickedInfo,
      setViewType: (viewType) => set(() => ({ viewType })),
      setColumnShowType,
      setFields,
      setOperationSwitch: (showOperation) => set(() => ({ showOperation })),
      setDefaultFilters: (defaultFilters) => set(() => ({ defaultFilters })),
      setMapRef: (mapRef) => set(() => ({ mapRef })),
    }

    const tbDataActions = {
      // 获取表单数据
      fetchTbData: (extParams) => {
        const {
          tbSlug,
          filters,
          sorts,
          pageSize,
          pageNum,
          setLoading,
          id,
          fields,
          listConfig,
        } = get()
        const { extend = {} } = ditto.tbDefs
        const { realCount } = extend
        const { returnSlugs } = listConfig || {}
        // setSelectedIds([])
        setLoading(true)
        ditto
          .fetchTbData({
            useAuth:
              tbSlug === 'diandanguanli_f5ee7b35_e42a_4a94_a4ab_3aab6b58cb1e' &&
              userInfoInApp.roleSlug === 'zdy_shijiansuo'
                ? false
                : true,
            filters: finalFetchDataFilters(filters, fields),
            sorts,
            pageSize,
            pageNum,
            vid: id,
            extParams,
            fields: returnSlugs,
          })
          .then((tbData) => {
            console.log('[use-tbview-data]', tbData)
            set(() => ({
              currentPageIds: tbData.map((v) => v.objectId),
              tbData,
              total: ditto.total,
              loading: false,
            }))
          })
        // 重新获取真实数据
        if (realCount === false) {
          ditto
            .fetchTableDataCount({
              filters: finalFetchDataFilters(filters, fields),
              sorts,
              pageSize,
              pageNum,
              vid: id,
            })
            .then(() => {
              set(() => ({
                total: ditto.total,
              }))
            })
        }
      },
      // 获取某条数据信息
      fetchTbDataById: (objectId, extProps = {}) => {
        return ditto
          .fetchById(objectId, {}, { ...extProps, useAuth: false })
          .then(async (itemData) => {
            const dealedData = await ditto.dealLazyData([itemData])
            const currentData =
              dealedData && dealedData.length > 0 && dealedData[0]
            // 这里需不需要更新tbData
            return { originalData: itemData, currentData }
          })
      },
      // 添加一条数据
      appendTbData: (newData) => {
        const { currentPageIds, tbData } = get()
        return ditto.createTbData(newData).then(async (createdData) => {
          setCurrentPageIds([createdData.objectId, ...currentPageIds])
          const dealedData = await ditto.dealLazyData([createdData])
          setTbData([...dealedData, ...tbData])
        })
      },
      // 更新一条数据
      updateTbData: (updateData, extProps) => {
        const { tbData } = get()
        return ditto.updateTbData(updateData, extProps).then(async (data) => {
          const dealedData = await ditto.dealLazyData([data])
          const nowData = dealedData && dealedData.length && dealedData[0]
          setTbData(
            tbData.map((v) => {
              if (v.objectId === updateData.objectId) {
                return { ...data, ...nowData, objectId: updateData.objectId }
              }
              return v
            })
          )
          return nowData
        })
      },
      // 更新规定的ids数据
      freshTbDataByIds: (ids) => {
        const { tbData } = get()
        return ditto.fetchByIds(castArray(ids)).then(async (data) => {
          const dealedData = await ditto.dealLazyData(data)

          setTbData(
            tbData.map((v) => {
              if (ids.includes(v.objectId)) {
                return dealedData.find((d) => d.objectId === v.objectId) || v
              }
              return v
            })
          )
        })
      },
      customProcessFreshTbDataByIds: (ids) => {
        const { tbData, fields, filters = {}, total } = get()

        return ditto
          .fetchByIds(castArray(ids), finalFetchDataFilters(filters, fields))
          .then(async (data) => {
            const dealedData = await ditto.dealLazyData(data)
            const backIds = dealedData.map((v) => v.objectId)
            const arrUpdate =
              difference(backIds, ids).length === 0
                ? backIds
                : difference(backIds, ids)
            const arrRemove = difference(ids, backIds)

            // tbData 没有的,可更新的至 tbData的
            const arrAdd = difference(
              ids,
              tbData.map((v) => v.objectId)
            ).filter((v) => dealedData.map((d) => d.objectId).includes(v))

            const arrConcat = dealedData.filter((v) =>
              arrAdd.includes(v.objectId)
            )

            const arr = tbData
              .map((v) => {
                if (arrUpdate.includes(v.objectId)) {
                  return dealedData.find((d) => d.objectId === v.objectId) || v
                }
                return v
              })
              .filter((v) => !arrRemove.includes(v.objectId))
              .concat(arrConcat)
            set(() => ({
              tbData: arr,
              total: total - arrRemove.length + arrConcat.length,
            }))
          })
      },
      // 回收数据
      recoverTbData: (objectIds) => {
        const ids = castArray(objectIds)
        const { tbData, selectedIds } = get()
        const data = {
          slugs: ['isFakeDeleted'],
          datas: { isFakeDeleted: false },
          objectIds: ids,
        }
        return ditto.batchUpdateTbData(data, ids).then(() => {
          set(() => ({
            tbData: tbData.filter((v) => !objectIds.includes(v.objectId)),
            selectedIds: selectedIds.filter((v) => !ids.includes(v)),
          }))
        })
      },
      // 批量更新数据
      batchUpdateTbData: (data, objectIds) => {
        const { tbData } = get()
        return ditto
          .batchUpdateTbData(data, objectIds)
          .then(async (updateData) => {
            const dealedData = await ditto.dealLazyData(updateData)
            setTbData(
              tbData.map((v) => {
                const obj = dealedData.find(
                  (item) => item.objectId === v.objectId
                )
                if (obj) {
                  return { ...v, ...obj }
                }
                return v
              })
            )
            return dealedData
          })
      },
      // 删除数据
      destroyTbData: (objectIds) => {
        const ids = castArray(objectIds)
        const { tbData, selectedIds, currentPageIds, total, recycleConfig } =
          get()
        // const isFakeDeletedField = fields.find(
        //   (v) => v.slug === 'isFakeDeleted'
        // )

        return (
          recycleConfig &&
          recycleConfig.allow &&
          typeof ditto.destroyTbDataToRecycle === 'function'
            ? ditto.destroyTbDataToRecycle(ids)
            : ditto.destroyTbData(ids)
        ).then(() => {
          set(() => ({
            currentPageIds: currentPageIds.filter((v) => v === v.objectId),
            tbData: tbData.filter((v) => !ids.includes(v.objectId)),
            selectedIds: difference(selectedIds, ids),
            total: total - ids.length,
          }))
        })
      },
      // 数据判重
      judgeDataRepeat: (data) => {
        const { collectorConfig } = get()
        const { repeatVerifiyfilters } = collectorConfig || {}
        const queries = repeatVerifiyfilters.queries.map((v) => {
          v.value = data[v.slug]
          return v
        })
        return ditto
          .fetchTbOriginalData({
            filters: {
              ...repeatVerifiyfilters,
              queries,
            },
            pageSize: 1,
          })
          .then((repeatData) => {
            const obj = repeatData && repeatData.length && repeatData[0]
            return obj.objectId !== data.objectId && obj
          })
      },
      // 数据重排
      sortTbData: (action) => {
        const { type, rowData } = action
        const { tbData } = get()
        const index = tbData.findIndex(
          (item) => item.objectId === rowData.objectId
        )
        if (type === 'up') {
          setTbData(swap(tbData, index, index - 1))
        } else if (type === 'down') {
          setTbData(swap(tbData, index, index + 1))
        } else if (type === 'top') {
          setTbData([
            tbData[index],
            ...tbData.slice(0, index),
            ...tbData.slice(index + 1),
          ])
        } else if (type === 'bottom') {
          setTbData([
            ...tbData.slice(0, index),
            ...tbData.slice(index + 1),
            tbData[index],
          ])
        }
      },
      // 更新排序
      updateNodeOrder: (filter) => {
        const { tbData } = get()
        const objects = {}
        let list = tbData
        if (typeof filter === 'function') {
          list = tbData.filter(filter)
        }

        list.forEach((item, index) => {
          objects[item.objectId] = index
        })

        return ditto.updateNodeOrder(objects)
      },
    }

    const mapModeActions = {}

    const allActions = {
      // init,
      ...initedState,
      ...setActions,
      ...tbDataActions,
      ...mapModeActions,
      ...extendsHooks,
    }

    let extendsActions = {}

    const initialFilters = initState.filters || {}

    if (extendsStore) {
      extendsActions = extendsStore(set, get, allActions)
    }
    const { filters: extendsFilters, useDefaultFilters } = extendsActions
    if (extendsFilters && extendsFilters.queries) {
      initialFilters.queries = useDefaultFilters
        ? extendsFilters.queries
        : (initialFilters.queries || []).concat(extendsFilters.queries)
    }

    const filtersQueries = dealInitialFilters(
      initialFilters,
      userInfoInApp,
      true
    )
    initialFilters.queries = filtersQueries
    initedState.filters = initialFilters
    initedState.finalFetchDataFilters = initialFilters
    initedState.defaultFilters = initialFilters

    return {
      ...allActions,
      ...initedState,
      ...extendsActions,
      filters: initedState.filters,
    }
  }
}
